import { IonInput, isPlatform, IonButton } from '@ionic/react'
import { BaseSyntheticEvent, useRef } from 'react'
import { Color, TextFieldTypes } from '@ionic/core'
import styled from 'styled-components'

type Props = {
  type: TextFieldTypes
  inputType: 'INPUT' | 'TEXTAREA'
  inputStyle?: 'BOX'
  inputmode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search'
  placeholder?: string
  onInput?: (value: string | number) => void
  color?: Color
  required?: boolean
  buttonTitle?: string
  isRightText?: boolean
  onClick?: () => void
  value?: string | number
}

export const StyleIonInputValue: React.FC<Props> = ({
  type,
  placeholder,
  onInput,
  color,
  inputmode,
  required,
  buttonTitle,
  inputType,
  inputStyle,
  isRightText,
  onClick,
  value,
}) => {
  const inputValue = useRef<HTMLIonInputElement>(null)
  return (
    <>
      {inputType === 'INPUT' && (
        <InputContainer isRightText={isRightText} inputStyle={inputStyle} buttonTitle={buttonTitle}>
          <IonInput
            mode={'ios'}
            aria-label="input"
            ref={inputValue}
            onTouchStart={() => {
              if (isPlatform('android')) {
                inputValue.current?.setFocus()
              }
            }}
            onInput={(e: BaseSyntheticEvent) => onInput != undefined && onInput(e.target.value)}
            inputmode={inputmode ? inputmode : 'numeric'}
            color={color ? color : 'dark'}
            type={type}
            placeholder={placeholder}
            required={required ? required : true}
            min={1}
            value={value}
          />
          {buttonTitle && <IonButton onClick={onClick}>{buttonTitle}</IonButton>}
        </InputContainer>
      )}
    </>
  )
}

const InputContainer = styled.div<{
  isRightText?: boolean
  buttonTitle?: string
  inputStyle?: 'BOX'
}>`
  position: relative;
  width: 100%;
  ion-input {
    color: var(--ion-color-primary_dark);
    border-radius: 8px;
    --border-radius: 8px;
    --placeholder-color: var(--ion-color-primary_light);
    --padding-top: ${(props) => (props.inputStyle === 'BOX' ? '10px' : '16px')};
    --padding-bottom: ${(props) => (props.inputStyle === 'BOX' ? '10px' : '16px')};
    --padding-start: 16px;
    --padding-end: ${(props) => (!props.buttonTitle ? '16px' : '80px')};
    --background: ${(props) => props.inputStyle === 'BOX' && 'var(--ion-color-gray100)'};
    text-align: ${(props) => props.isRightText && 'end'};
    @media (prefers-color-scheme: light) {
      border: ${(props) =>
        props.inputStyle === 'BOX' ? 'solid 1px #00000000 !important' : 'solid 1px #e9e9e9 !important'};
    }
    @media (prefers-color-scheme: dark) {
      border: ${(props) =>
        props.inputStyle === 'BOX' ? 'solid 1px #00000000 !important' : 'solid 1px #30363a !important'};
    }
  }
  .has-focus {
    @media (prefers-color-scheme: light) {
      border: solid 1px #1a1f27 !important;
      border-radius: 8px;
    }
    @media (prefers-color-scheme: dark) {
      border: solid 1px #f7f8f9 !important;
      border-radius: 8px;
    }
  }
  ion-button {
    z-index: 2;
    position: absolute;
    font-size: 11px;
    font-weight: 600;
    color: #ffffff;
    bottom: 7px;
    right: 4px;
    float: right;
    padding: 3.5px 8px;
    --border-radius: 4px;
    --padding-top: 8px;
    --padding-bottom: 8px;
    --padding-end: 8px;
    --padding-start: 8px;
  }
`
